import Vue from 'vue';
import Router from 'vue-router';

import Home from '../views/Home.vue';
import RulesView from '../views/RulesView.vue';

Vue.use(Router);

// 单页官网：所有路径都指向 Home，
// 旧路径(/events、/courses 等)重定向到 /，URL 上的 hash 可继续工作。
export default new Router({
  mode: 'history',
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/rules', name: 'rules', component: RulesView },
    { path: '/events', redirect: '/' },
    { path: '/events/:id', redirect: '/' },
    { path: '/courses', redirect: '/' },
    { path: '/courses/:id', redirect: '/' },
    { path: '/clubs', redirect: '/' },
    { path: '/clubs/:id', redirect: '/' },
    { path: '/news', redirect: '/' },
    { path: '/news/:id', redirect: '/' },
    { path: '*', redirect: '/' },
  ],
});